import * as React from 'react'
//

function Ministry() {
    return (
        <p>Ministry</p>
    )
}

export default Ministry
